/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileMonthResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type FileMonthResponse, type HttpValidationProblemDetails, type IError } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/months
 */
export interface MonthsRequestBuilder extends BaseRequestBuilder<MonthsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileMonthResponse[]>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<MonthsRequestBuilderGetQueryParameters> | undefined) : Promise<FileMonthResponse[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<MonthsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface MonthsRequestBuilderGetQueryParameters {
    directoryId?: Guid;
    tagId?: Guid;
}
/**
 * Uri template for the request builder.
 */
export const MonthsRequestBuilderUriTemplate = "{+baseurl}/files/months{?directoryId*,tagId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const MonthsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MonthsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createFileMonthResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
